module.exports = __webpack_public_path__ + "2acb60f2/img/cadBim.e369a02a.png";